import dayjs from "dayjs";
import { useCallback } from "react";

export function useFormatDateTime() {
  return useCallback((dateTime: string | number | undefined | null, format: string, fallback: string = "--") => {
    if (!dateTime) return fallback;
    const date = dayjs(dateTime);
    if (!date.isValid()) return fallback;
    return date.format(format);
  }, []);
}
